// import React from "react";
// import { motion } from "framer-motion";

// import "./AboutUs.css";
// import GSTDetails from "../GSTDetails/GSTDetails";
// import TeamSection from "./TeamSection";
// import CustomerStories from "./CustomerStories";
// import AboutHero from "./AboutHero";
// import CTASection from "../CTASection/CTASection";
// import historyImg from "../../assets/Aboutsectionimg/History.webp";
// import Mission from "../../assets/Aboutsectionimg/Mission.webp";

// function AboutUs() {
//   return (
//     <div className="about-container">
//       <AboutHero />

//       <div className="about-section about-row">
//         <motion.div
//           className="about-image"
//           initial={{ opacity: 0, x: -80 }}
//           whileInView={{ opacity: 1, x: 0 }}
//           transition={{ duration: 0.8, ease: "easeOut" }}
//           viewport={{ once: false, amount: 0.3 }}
//         >
//           <img src={historyImg} alt="History" />
//         </motion.div>

//         <motion.div
//           className="about-text"
//           initial={{ opacity: 0, x: 80 }}
//           whileInView={{ opacity: 1, x: 0 }}
//           transition={{ duration: 0.8, ease: "easeOut" }}
//           viewport={{ once: false, amount: 0.3 }}
//         >
//           <h2>Our History</h2>
//           <p>
//             Founded in 2010, Atlas Travels began with a simple vision — to make
//             every journey more than just a trip. What started as a small
//             initiative has grown into a trusted travel brand, built on passion,
//             commitment, and the belief that travel connects people to places,
//             cultures, and stories. Over the years, we have expanded our horizons
//             from local getaways to international destinations, serving thousands
//             of travelers with personalized care and attention. Every milestone
//             in our journey reflects not just growth in numbers, but growth in
//             trust and relationships we’ve built with our clients. Today, Atlas
//             Travels stands as a symbol of reliability and excellence in the
//             travel industry, offering curated experiences, seamless services,
//             and a promise to turn every journey into a lasting memory. Our
//             history is not just about where we started — it’s about how far
//             we’ve come, and the countless journeys we’ve had the honor to be a
//             part of.
//           </p>
//         </motion.div>
//       </div>

//       <TeamSection />

//       <div className="about-section about-row reverse">
//         <motion.div
//           className="about-image"
//           initial={{ opacity: 0, x: 80 }}
//           whileInView={{ opacity: 1, x: 0 }}
//           transition={{ duration: 0.8, ease: "easeOut" }}
//           viewport={{ once: false, amount: 0.3 }}
//         >
//           <img src={Mission} alt="Mission" />
//         </motion.div>

//         <motion.div
//           className="about-text"
//           initial={{ opacity: 0, x: -80 }}
//           whileInView={{ opacity: 1, x: 0 }}
//           transition={{ duration: 0.8, ease: "easeOut" }}
//           viewport={{ once: false, amount: 0.3 }}
//         >
//           <h2>Our Mission</h2>
//           <p>
//             At Atlas Travels, our mission goes beyond just planning trips — we
//             aim to craft journeys that inspire, connect, and transform. We are
//             committed to delivering seamless travel experiences where every
//             detail is thoughtfully designed, every service is driven by trust,
//             and every moment creates lasting memories. With innovation at our
//             core and customer satisfaction as our guiding principle, we strive
//             to bridge cultures, bring people closer to the world, and redefine
//             what it means to truly travel. Our mission is not just to take you
//             places, but to make every journey a story worth telling.
//           </p>
//         </motion.div>
//       </div>

//       <motion.div
//         className="about-section"
//         initial={{ opacity: 0, y: 50 }}
//         whileInView={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.8, ease: "easeOut" }}
//         viewport={{ once: false, amount: 0.3 }}
//       >
//         <h2>Why Choose Us?</h2>
//         <ul className="about-list">
//           <li> 10+ Years of Expertise in Corporate & Leisure Travel</li>
//           <li> 50+ Destinations Covered</li>
//           <li> Trusted by Renowned Corporate Clients</li>
//           <li> Personalized, Hassle-Free Planning</li>
//           <li> 24/7 Customer Support</li>
//         </ul>
//       </motion.div>

//       <div className="about-section about-row">
//         <div className="about-presence">
//           <GSTDetails />
//         </div>
//       </div>

//       <div className="about-section">
//         <CustomerStories />
//       </div>
//     </div>
//   );
// }

// export default AboutUs;


import React from "react";
import { motion } from "framer-motion";

import "./AboutUs.css";
import GSTDetails from "../GSTDetails/GSTDetails";
import TeamSection from "./TeamSection";
import CustomerStories from "./CustomerStories";
import AboutHero from "./AboutHero";
import CTASection from "../CTASection/CTASection";
import historyImg from "../../assets/Aboutsectionimg/History.webp";
import Mission from "../../assets/Aboutsectionimg/Mission.webp";

function AboutUs() {
  return (
    <div className="about-container">
      <AboutHero />

      <div className="about-section about-row">
        <motion.div
          className="about-image"
          initial={{ opacity: 0, x: -80 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: false, amount: 0.3 }}
        >
          <img src={historyImg} alt="History" />
        </motion.div>

        <motion.div
          className="about-text"
          initial={{ opacity: 0, x: 80 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: false, amount: 0.3 }}
        >
          <h2>Our History</h2>
<p>
  Established in 2010, <strong>Atlas Travel House</strong> began with a simple mission—creating travel 
  experiences that are meaningful, memorable and effortlessly smooth. What started as a small initiative 
  has grown into a trusted name in the travel and events industry, driven by passion, reliability and a 
  deep commitment to customer satisfaction.
  <br/>
  Over the years, we’ve expanded from local tours to global destinations, serving thousands of travelers 
  with personalized planning and seamless execution. Each milestone reflects not just business growth but 
  the lasting relationships and trust we’ve built with our clients.
  <br></br>
  Today, <strong>Atlas Travel House</strong> stands as a symbol of excellence—offering curated itineraries, 
  corporate MICE solutions and world-class travel services. Our history is more than our origin story; 
  it’s a journey shaped by the people we serve and the unforgettable experiences we help create.
</p>

        </motion.div>
      </div>

      <TeamSection />

      <div className="about-section about-row reverse">
        <motion.div
          className="about-image"
          initial={{ opacity: 0, x: 80 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: false, amount: 0.3 }}
        >
          <img src={Mission} alt="Mission" />
        </motion.div>

        <motion.div
          className="about-text"
          initial={{ opacity: 0, x: -80 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: false, amount: 0.3 }}
        >
        <h2>Our Mission</h2>
        <p> At <strong>Atlas Travel House</strong>, our mission is to create meaningful travel experiences that go far beyond traditional trip planning. We are dedicated to designing seamless, personalized journeys where every detail reflects comfort, reliability, and care. With a strong focus on innovation and customer satisfaction, we aim to make travel more accessible, enriching, and memorable for every explorer. Our mission is to connect people with destinations, cultures, and stories — turning every journey into an experience that inspires growth, strengthens relationships, and stays with you for a lifetime. </p>
        </motion.div>
      </div>

      <motion.div
        className="about-section"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: false, amount: 0.3 }}
      >
        <h2>Why Choose Us?</h2>
        <ul className="about-list">
          <li> 10+ Years of Expertise in Corporate & Leisure Travel</li>
          <li> 50+ Destinations Covered</li>
          <li> Trusted by Renowned Corporate Clients</li>
          <li> Personalized, Hassle-Free Planning</li>
          <li> 24/7 Customer Support</li>
        </ul>
      </motion.div>

      <div className="about-section about-row">
        <div className="about-presence">
          <GSTDetails />
        </div>
      </div>

      <div className="about-section">
        <CustomerStories />
      </div>
    </div>
  );
}

export default AboutUs;
